import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ConfigAssetLoaderService } from '../config/config-asset-loader.service';
import { LoaderService } from '../loader/loader.service';

@Injectable({
  providedIn: 'root',
})
export class LoaderInterceptor implements HttpInterceptor {
  private totalRequests = 0;

  constructor(
    public loaderService: LoaderService,
    private configService: ConfigAssetLoaderService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.totalRequests++;
    const config = this.configService.getConfig();
    let tokenUrl;
    if (config) {
      tokenUrl = config.ssoIssuer + '/protocol/openid-connect/token';
    }

    if (req && req.url && !req.url.startsWith(tokenUrl)) {
      this.loaderService.isLoading.next(true);
    }

    return next.handle(req).pipe(
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests === 0) {
          this.loaderService.isLoading.next(false);
          //console.log('loading over');
        }
      })
    );
  }
}
